'use client'
import Image from 'next/image'
import { useRouter } from 'next/navigation'
import React, { useEffect, useState } from 'react'
import Lottie from 'react-lottie'

import collect from '@/utils/daangnEvents/purchase'
import paymentEvents from '@/utils/gaEvents/paymentEvents'

import Button from '@/shared/components/button/Button'
import Cover from '@/shared/components/Cover'
import NaverPreLog from '@/shared/components/scripts/NaverPreLog'
import NaverPreLogPurchase from '@/shared/components/scripts/NaverPreLogPurchase'
import Toast from '@/shared/components/Toast'
import { Text, Title } from '@/shared/components/typography'

import purchaseAnimation from '../../../../../../public/paymentcheck.json'

import { requestAuthGuest } from '@/api/client/purchase'
import NotFound from '@/app/not-found'
import { ClientRequestError } from '@/lib/axiosClient'

export type PurchaseStatusCheckProps = {
  params: { id: string }
  searchParams: {
    statusCheck: string
    couSeq: string
    type: string
    guestCode: string
    result: string
    guestSeq: string
  }
  isComplete: boolean
}

const PurchaseStatusCheck = ({ isComplete, searchParams, params }: PurchaseStatusCheckProps) => {
  const router = useRouter()
  const [toastText, setToastText] = useState('')
  const [isErrorToast, setIsErrorToast] = useState(false)
  const [data, setData] = useState({
    guestCode: '',
    guestSeq: '',
    result: '',
    type: '',
    couSeq: ''
  })

  useEffect(() => {
    if (searchParams.result) {
      collect()
      paymentEvents.partner.completePayment(Number(searchParams.couSeq))
      setData({
        guestCode: searchParams.guestCode,
        guestSeq: searchParams.guestSeq,
        result: searchParams.result,
        type: searchParams.type,
        couSeq: searchParams.couSeq
      })
      router.replace(`/t/${params.id}?statusCheck=${searchParams.result}`)
    }
  }, [searchParams])

  const onClickShowMyTicketDetail = async () => {
    try {
      if (!data.couSeq || !data.type || !data.guestCode) {
        setIsErrorToast(true)
        setToastText('오류가 발생했습니다. 연락처로 발송된 주차권을 통해 확인해주세요.')
        router.replace('/')
      }
      const payload = {
        guestSeq: Number(data.guestSeq)
      }
      const { data: authGuestData } = await requestAuthGuest(payload)
      router.replace(
        `/my-ticket/${data.couSeq}?type=${data.type}&guestCode=${data.guestCode}&token=${authGuestData.accessToken}`
      )
    } catch (err: unknown) {
      if (err instanceof ClientRequestError) {
        setIsErrorToast(true)
        setToastText(err.message)
      } else {
        throw err
      }
    }
  }

  const onClickShowTicketDetail = () => {
    router.replace(`/t/${params.id}`)
  }
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: purchaseAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }

  if (searchParams.statusCheck && !data.couSeq) return NotFound()
  return (
    <Cover isOpen className="left-0 top-0 flex h-full w-full flex-1 flex-col bg-010">
      <div className="mb-9 flex w-full flex-1 flex-col items-center justify-center">
        {isComplete && (
          <div className="mb-6">
            <Lottie options={defaultOptions} width={50} height={50} />
          </div>
        )}
        <Title level="title3" color="text090" weight="bold">
          {isComplete ? '주차권 결제 완료' : '결제가 완료되지 않았습니다.'}
        </Title>
        {!isComplete && (
          <>
            <div className="mt-[3px]">
              <Text level="text2" color="text090">
                다시 결제를 진행해주세요.
              </Text>
            </div>
            <Image
              src="/images/light_img_payfailed.png"
              alt="결제미완료"
              width={0}
              height={0}
              style={{ width: '70%', height: 'auto' }}
            />
          </>
        )}
        {isComplete && (
          <div className="mt-6 text-center">
            <Text level="text2" color="main050">
              주차권 유의사항 미숙지로 인한 <br />
              피해 보상은 불가합니다.
            </Text>
          </div>
        )}
      </div>
      <div className="sticky bottom-0 px-4 pb-3">
        <Button
          text={isComplete ? '주차권 보기' : '다시 결제하기'}
          color="text010"
          background="bg030"
          className="body-1 h-[56px]"
          pyValue="py-0"
          disabled={false}
          onClick={isComplete ? onClickShowMyTicketDetail : onClickShowTicketDetail}
        />
      </div>
      {isErrorToast && (
        <Toast
          text={toastText}
          onClose={() => {
            setIsErrorToast(false)
          }}
          position="top"
        />
      )}
      <NaverPreLog />
      <NaverPreLogPurchase />
    </Cover>
  )
}

export default PurchaseStatusCheck
